import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class EnderecoUtils {

    private readonly estados = [
        'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
        'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
        'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
    ];

    public ufList = this.estados.map(uf => ({
        estado: uf,
        descricao: uf
    }));

}